<template>
<div>
  <div v-if="loading">
    <Loading> </Loading>
  </div>
<div v-if="!loading">
<v-container fluid>
  <v-btn class="primary" @click="ExportExcel()">Download to excel</v-btn>
  <v-card-title>
    <h2 class="primary--text">Bookings</h2>
    <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field> 
  </v-card-title>
  <br/>
  <v-data-table
    id="table"
    dense
    :headers="headers"
    :items="getBookings"
    :search="search"
    @click:row="handleEvent"
    class="elevation-1 data-row"
  >
  </v-data-table>
  <br/>
  <v-btn v-on:click="loadMore" :disabled="pageEnd" class="primary mr-10">Load More</v-btn>
</v-container>
</div>
</div>
</template>
<script>
import Loading from '@/components/Loading';   
import 'table2excel'; 

export default {
  name: 'Bookings',
 components: {
    Loading
  },
  data() {
    return {
      headers: [
        {
          text: 'Id',
          align: 'start',
          sortable: true,
          value: 'id',
          filterable: true,
        },
        { text: 'Booking Number', value: 'orderNumber' },
        { text: 'Scheduled Date', value: 'date' },
        { text: 'Actual Date', value: 'actualDate' },
        { text: 'Customer', value: 'customer' },
        { text: 'Company', value: 'company' },
        { text: 'Address', value: 'address' },
        { text: 'Waste', value: 'wasteName' },
        { text: 'Vehicle', value: 'vehicleName' },
        { text: 'Driver', value: 'driverName' },
        { text: 'Type', value: 'type' },
        { text: 'Status', value: 'status' },
        { text: 'Charge (ZAR)', value: 'cost' }
      ],
      bookingData: [],
      search: '',
    }
  },
  watch: {
    getBookings(bookings){
      if (bookings.length < 1) {
        alert('There are no available bookings yet');
      }
    }
  },
  computed: {
    loading(){
      return this.$store.getters['admin/getLoading'];
    },
    getBookings(){
      return this.$store.getters['admin/getCharges'];
    },
    query(){
      return this.$store.getters['admin/getChargesQuery'];
    },
    pageEnd(){
      return this.$store.getters['admin/getChargesPageEnd'];
    }
  },
  methods: {
    loadMore(){
      this.$store.dispatch('admin/fetchCharges', {bookingQuery: this.query, isLoadMore: true});
    },
    ExportExcel() {
      const Table2Excel = window.Table2Excel;
      const table2excel = new Table2Excel();
      table2excel.export(document.querySelectorAll("table"));
    },
    handleEvent(value){
      switch(value.type){
        case 'DELIVERY':
          location.href = '/dashboard/deliveryBookings';
          break;
        case 'EXCHANGE':
          location.href = '/dashboard/exchangeBookings';
          break;
        case 'COLLECTION': 
          location.href ='/dashboard/collectionBookings';
          break;
        case 'LOAD':
          location.href ='/dashboard/truckBookings';
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    if(this.getBookings.length === 0){
      this.$store.dispatch('admin/fetchCharges', {bookingQuery: this.query, isLoadMore: false});
    }
  }
}
</script>

<style scoped>
.data-row{
  cursor: pointer;
}
</style>